<template>
    <!-- 面包屑导航 -->
    <div class="header">
        <!-- <ul>
            <li class="bread" v-for="item in breadData" :key="item.path" :class="currentRoute.path==item.path?'active':''" @click="changePage(item)">
                {{item.title}}
            </li>
            <li>北京市房山区中小学生生命健康教育平台</li>
        </ul> -->
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
export default{
    name:'Spread',
    props:{
        // 接收当前路由
        currentRoute:{
            type:Object,
        }
    },
    computed:{
        // 面包屑路由
        ...mapState('Bread',['breadData']),
    },
    created(){
        let currentPath = this.currentRoute.path
        // 点击路由时 当前路由不存在则添加
        let result = this.breadData.find(item=>{
            return item.path == currentPath
        })
        if(!result){
            this.addTobread(this.currentRoute)
        }
    },
    methods:{
        ...mapMutations('Bread',['addTobread']),
        // 跳转页面
        changePage(item){
            this.$router.push({
                path:item.path
            })
        }
    },
    
}
</script>
<style lang="less" scoped>
  .header {
    display: flex;
    align-items: center;
    width: 8.5417rem;
    // height: .3472rem;
    // border-top: .0069rem solid #D9D9D9;
    background: white;
    color: #999999;
    font-weight: bold;
    .bread {
      display: inline-block;
      margin-left: .1389rem;
    //   width: .6181rem;
      height: .25rem;
      line-height: .25rem;
      text-align: center;
      font-size: 0.1111rem;
      cursor: pointer;
    }
  }
  .active{
    color: #d9221a;
    font-weight: bold;
    border-bottom: .0069rem solid #D9221A;
  }
</style>


// WEBPACK FOOTER //
// src/components/Spread.vue